"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ResidentDto {
}
exports.ResidentDto = ResidentDto;
